import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'functions_as_vars',
    dependencies: [
        'levels/overriding_vars',
        'levels/conditions',
        'levels/advanced_functions'
    ]
})



level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(0, 5)
        let b = random.intBetween(0, 5)
        if (b === a) {
            b += 2
        }
        let name = random.pick('hi', 'hello')
        q.addJSCode(
            'function hi (a, b) {'
            + '\n\treturn a + b'
            + '\n}'

            + '\n\nfunction hello (a, b) {'
            + '\n\treturn a * b'
            + '\n}'

            + '\n\nlet bonjour = ' + name

            + '\n\nbonjour(' + a + ', ' + b + ')'
        )
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(0, 5)
        let b = random.intBetween(0, 5)
        if (b === a) {
            b += 2
        }
        q.addJSCode(
            'function hi (a, b) {'
            + '\n\treturn a + b'
            + '\n}'

            + '\n\nfunction hello (a, b) {'
            + '\n\treturn a * b'
            + '\n}'

            + '\n\nhello = hi'

            + '\n\nhello(' + a + ', ' + b + ')'
        )
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(0, 5)
        let b = random.intBetween(0, 5)
        if (b === a) {
            b += 2
        }
        q.addJSCode(
            'let bonjour = ' + random.intBetween(1, 99)

            + '\n\nfunction hello (a, b) {'
            + '\n\treturn a * b'
            + '\n}'

            + '\n\nbonjour = hello'

            + '\n\nbonjour(' + a + ', ' + b + ')'
        )
    },
    times: 2
})



level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(0, 5)
        let b = random.intBetween(0, 5)
        if (b === a) {
            b += 2
        }
        let c = random.intBetween(0, 20)
        let d = random.intBetween(0, 20)
        if (c === d) {
            c += 1
        }
        q.addJSCode(
            'let bonjour = ' + random.intBetween(1, 99)

            + '\n\nfunction hi (a, b) {'
            + '\n\treturn a + b'
            + '\n}'

            + '\nfunction hello (a, b) {'
            + '\n\treturn a * b'
            + '\n}'

            + '\n\nif (' + c + ' < ' + d + ') {'
            + '\n\tbonjour = hi'
            + '\n} else {'
            + '\n\tbonjour = hello'
            + '\n}'

            + '\n\nbonjour(' + a + ', ' + b + ')'
        )
    },
    times: 2
})


export default level

